const transactionType = {
  PURCHASE: '00',
  REFUND: '03',
  VOID: '05',
};

export { transactionType };
